import dayjs from "dayjs";
import { BookedClassRoomDto } from "../../BookedClassRooms/types.ts";
import { ActivityPeriod, isWithinPeriod } from "./activityPeriod.ts";
import { shareOf } from "./shareOf.ts";

export type AssignmentOutcome = {
  wonClassRooms: number;
  lostClassRooms: number;
  winRate: number | null;
};

export function classRoomsStartedInPeriod(
  classRooms: BookedClassRoomDto[],
  period: ActivityPeriod,
): BookedClassRoomDto[] {
  return classRooms.filter((classRoom) =>
    isWithinPeriod(dayjs(classRoom.startUtc), period),
  );
}

export function classRoomsOfTeacher(
  classRooms: BookedClassRoomDto[],
  teacherId: string,
): BookedClassRoomDto[] {
  return classRooms.filter((classRoom) => classRoom.teacherId === teacherId);
}

export function classRoomsOfOtherTeachers(
  classRooms: BookedClassRoomDto[],
  teacherId: string,
): BookedClassRoomDto[] {
  return classRooms.filter((classRoom) => classRoom.teacherId !== teacherId);
}

export function assignmentOutcome({
  teacherId,
  classRooms,
  classRoomIdsLostByTeacher,
}: {
  teacherId: string;
  classRooms: BookedClassRoomDto[];
  classRoomIdsLostByTeacher: Set<string>;
}): AssignmentOutcome {
  const wonClassRooms = classRoomsOfTeacher(classRooms, teacherId).length;
  const lostClassRooms = classRoomsOfOtherTeachers(
    classRooms,
    teacherId,
  ).filter((classRoom) =>
    classRoomIdsLostByTeacher.has(classRoom.classRoomId),
  ).length;
  return {
    wonClassRooms,
    lostClassRooms,
    winRate: shareOf(wonClassRooms, wonClassRooms + lostClassRooms),
  };
}
